module.exports = __webpack_public_path__ + "assets/images/pages/job/planet.png?f050d12e";